/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ProductInputs */

const en_common_product = /** @type {(inputs: Common_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const es_common_product = /** @type {(inputs: Common_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Common_ProductInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_product = /** @type {((inputs?: Common_ProductInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ProductInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_product(inputs)
	return en_common_product(inputs)
});